import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', JSON.stringify({
      necessary: true,
      functional: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookie-consent', JSON.stringify({
      necessary: true,
      functional: false,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom">
      <Card className="max-w-4xl mx-auto bg-white shadow-2xl border-slate-200">
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <Cookie className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900">Cookie-Einstellungen</h3>
                <p className="text-sm text-slate-600">Wir respektieren Ihre Privatsphäre</p>
              </div>
            </div>
            <button
              onClick={acceptNecessary}
              className="text-slate-400 hover:text-slate-600 transition-colors"
              aria-label="Schließen"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <p className="text-slate-700 mb-6">
            Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Einige Cookies sind notwendig für die Funktionalität der Website, während andere uns helfen, die Nutzung zu analysieren und Inhalte zu personalisieren.
          </p>

          <div className="space-y-3 mb-6">
            <div className="flex items-start space-x-3 p-3 bg-slate-50 rounded-lg">
              <input type="checkbox" checked disabled className="mt-1" />
              <div className="flex-1">
                <p className="font-semibold text-slate-900 text-sm">Notwendige Cookies</p>
                <p className="text-xs text-slate-600">Erforderlich für die Grundfunktionen der Website</p>
              </div>
            </div>
            <div className="flex items-start space-x-3 p-3 bg-slate-50 rounded-lg">
              <input type="checkbox" defaultChecked className="mt-1" />
              <div className="flex-1">
                <p className="font-semibold text-slate-900 text-sm">Funktionale Cookies</p>
                <p className="text-xs text-slate-600">Speichern Ihre Einstellungen und Präferenzen</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              onClick={acceptAll}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white"
            >
              Alle akzeptieren
            </Button>
            <Button
              onClick={acceptNecessary}
              variant="outline"
              className="flex-1 border-slate-300 hover:bg-slate-50"
            >
              Nur notwendige
            </Button>
            <Link to="/cookie-policy" className="flex-1">
              <Button
                variant="ghost"
                className="w-full text-slate-600 hover:text-slate-900"
              >
                Mehr erfahren
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CookieBanner;